import { useState } from 'react'

import { AccordionAnimatedContent } from '../../Accordion'

import { getBirdviewAttentionRowItems } from './BirdviewAttentionRow.utils'
import { BirdviewAttentionRowHeader } from './BirdviewAttentionRowHeader'

import * as styles from './BirdviewAttentionRow.module.css'

function BirdviewAttentionRow({
  activityDoneById,
  extra,
  item,
  pendingIds,
  requestActions,
  onActivityToggle,
  onOpenItem,
}) {
  const [isOpen, setIsOpen] = useState(item.isOpenByDefault)

  function handleToggle() {
    setIsOpen(open => !open)
  }

  return (
    <div className={styles.row}>
      <BirdviewAttentionRowHeader
        isOpen={isOpen}
        item={item}
        onToggle={handleToggle}
      />
      <AccordionAnimatedContent isOpen={isOpen}>
        {getBirdviewAttentionRowItems({
          activityDoneById,
          extra,
          items: item.items,
          pendingIds,
          requestActions,
          onActivityToggle,
          onOpenItem,
        })}
      </AccordionAnimatedContent>
    </div>
  )
}

export default BirdviewAttentionRow
